module.exports = __webpack_public_path__ + "static/conceptSmall1-ef906e7b6e166597e81d4655f873b229.jpg";